<button
    type="button"
    class="group flex w-full items-center justify-between border text-left transition focus:outline-none focus:ring-2 focus:ring-inset focus:ring-emerald-300 disabled:cursor-not-allowed disabled:opacity-60"
    [ngClass]="[
        cardSizeClass,
        checked
            ? 'border-emerald-300 bg-emerald-50/70 text-slate-900'
            : 'border-white/60 bg-white/50 text-slate-900 hover:bg-white/75'
    ]"
    [disabled]="disabled"
    [attr.aria-pressed]="checked"
    (click)="toggle()">
    <span class="min-w-0">
        <strong class="block truncate font-semibold text-slate-900" [ngClass]="titleClass">{{ title }}</strong>
        <span *ngIf="description" class="block truncate text-slate-500" [ngClass]="descriptionClass">
            {{ description }}
        </span>
    </span>
    <span
        class="flex shrink-0 items-center rounded-full p-0.5 transition"
        [ngClass]="[trackClass, checked ? 'bg-emerald-500' : 'bg-slate-300 group-hover:bg-slate-400']">
        <span
            class="rounded-full bg-white shadow transition"
            [ngClass]="[thumbClass, checked ? thumbTranslateClass : 'translate-x-0']"></span>
    </span>
</button>
